import { render, staticRenderFns } from "./BaseWarehouse.vue?vue&type=template&id=eb5f9562&scoped=true&"
import script from "./BaseWarehouse.vue?vue&type=script&lang=js&"
export * from "./BaseWarehouse.vue?vue&type=script&lang=js&"
import style0 from "./BaseWarehouse.vue?vue&type=style&index=0&id=eb5f9562&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "eb5f9562",
  null
  
)

export default component.exports